var mediaQuery = require('sensible');
var $ = require('jquery');
window.jQuery = $;
var swipebox = require('vendor/jquery.swipebox.min');


$( '.js-lightbox' ).swipebox({
    hideBarsDelay: 0,
    hideBarsOnMobile: false,
    afterOpen: function() {
      $('#swipebox-close').addClass('icon-close2 icon-large').html('<span class="icon-label">Schliessen</span>');
      $('#swipebox-prev').addClass('icon-left icon-large').html('<span class="icon-label">Zurück</span>');
      $('#swipebox-next').addClass('icon-right icon-large').html('<span class="icon-label">Vorwärts</span>');
      $('#swipebox-next, #swipebox-prev').css('background-image', '');
    }
  });



// WEBPACK FOOTER //
// ./resources/assets/js/components/gallery.js